import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

export class PartyModuleParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    title: {
      label: this.moduleParamConfigGlob.getLabel('party', 'title', 'Business Partner'),
    },
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('party', 'subtitle', 'Business Partner Details'),
    },
    basicDetail: {
      label: this.moduleParamConfigGlob.getLabel('party', 'basicDetail', 'Basic Details'),
    },
    party_name: {
      label: this.moduleParamConfigGlob.getLabel('party', 'party_name', 'Business Partner Name'),
    },
    party_type: {
      label: this.moduleParamConfigGlob.getLabel('party', 'party_type', 'Business Partner Type'),
    },
    product_type: {
      label: this.moduleParamConfigGlob.getLabel('party', 'product_type', 'Vendor Category'),
    },
    party_type_category: {
      label: this.moduleParamConfigGlob.getLabel('party', 'party_type_category', 'Business Partner Category'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'party_type_category'),
    },
    gst_number: {
      label: this.moduleParamConfigGlob.getLabel('party', 'gst_number', 'TAX Number'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'gst_number'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'gst_number'),
    },
    pan: {
      label: this.moduleParamConfigGlob.getLabel('party', 'pan', 'PAN'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'pan'),
    },
    country: {
      label: this.moduleParamConfigGlob.getLabel('party', 'country', 'Country'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'country'),
    },
    state: {
      label: this.moduleParamConfigGlob.getLabel('party', 'state', 'State'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'state'),
    },
    company_website: {
      label: this.moduleParamConfigGlob.getLabel('party', 'company_website', 'Company Website'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'company_website'),
    },
    transports: {
      label: this.moduleParamConfigGlob.getLabel('party', 'transports', 'Transporter Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'transports'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'transports'),
    },
    salesHead: {
      label: this.moduleParamConfigGlob.getLabel('party', 'salesHead', 'Sales Head'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'salesHead'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'salesHead'),
    },
    vendorCode: {
      label: this.moduleParamConfigGlob.getLabel('party', 'vendorCode', 'Business Partner Code'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'vendorCode'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'vendorCode'),
    },
    segment: {
      label: this.moduleParamConfigGlob.getLabel('party', 'segment', 'Segment'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'segment'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'segment'),
    },
    terms_of_payment: {
      label: this.moduleParamConfigGlob.getLabel('party', 'terms_of_payment', 'Terms Of Payment'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'terms_of_payment'),
    },
    billing_address: {
      label: this.moduleParamConfigGlob.getLabel('party', 'billing_address', 'Billing Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'billing_address'),
    },
    address: {
      label: this.moduleParamConfigGlob.getLabel('party', 'address', 'Address'),
    },
    streetAddress: {
      label: this.moduleParamConfigGlob.getLabel('party', 'streetAddress', 'Street Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'streetAddress'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'streetAddress'),
    },
    area: {
      label: this.moduleParamConfigGlob.getLabel('party', 'area', 'Area / City'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'area'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'area'),
    },
    pin: {
      label: this.moduleParamConfigGlob.getLabel('party', 'pin', 'Pin Code'),
      isRequired: this.moduleParamConfigGlob.isRequired('party', 'pin'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'pin'),
    },
    bankDetail: {
      label: this.moduleParamConfigGlob.getLabel('party', 'bankDetail', 'Bank Details'),
    },
    bank_name: {
      label: this.moduleParamConfigGlob.getLabel('party', 'bank_name', 'Bank Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'bank_name'),
    },
    ifsc_code: {
      label: this.moduleParamConfigGlob.getLabel('party', 'ifsc_code', 'IFSC Code'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'ifsc_code'),
    },
    holder_name: {
      label: this.moduleParamConfigGlob.getLabel('party', 'holder_name', 'Holder Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'holder_name'),
    },
    account_number: {
      label: this.moduleParamConfigGlob.getLabel('party', 'account_number', 'Account Number'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'account_number'),
    },
    shipping_address: {
      label: this.moduleParamConfigGlob.getLabel('party', 'shipping_address', 'Shipping Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('party', 'shipping_address'),
    },
  };
  contactDetailData = {
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'subtitle', 'Contact Details'),
    },
    first_name: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'first_name', 'First Name'),
    },
    last_name: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'last_name', 'Last Name'),
    },
    designation: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'designation', 'Designation'),
      isVisible: this.moduleParamConfigGlob.isVisible('partyContactDetails', 'designation'),
    },
    phone: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'phone', 'Phone'),
    },
    email: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'email', 'Email'),
    },
    secondary_phone: {
      label: this.moduleParamConfigGlob.getLabel('partyContactDetails', 'secondary_phone', 'Secondary Phone'),
      isVisible: this.moduleParamConfigGlob.isVisible('partyContactDetails', 'secondary_phone'),
    },
  };
  branchLocation = {
    default_Branch: {
      label: this.moduleParamConfigGlob.getLabel('PartyDetailsBranchModel', 'default_Branch', 'Default Branch'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyDetailsBranchModel', 'default_Branch'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyDetailsBranchModel', 'default_Branch'),
    },
    title: {
      label: this.moduleParamConfigGlob.getLabel('PartyDetailsBranchModel', 'title', 'Branch'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyDetailsBranchModel', 'title'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyDetailsBranchModel', 'title'),
    },
    addBranch: {
      label: this.moduleParamConfigGlob.getLabel('PartyDetailsBranchModel', 'addBranch', 'Add Branch'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyDetailsBranchModel', 'addBranch'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyDetailsBranchModel', 'addBranch'),
    },
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('PartyDetailsBranchModel', 'subtitle', 'Branch Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyDetailsBranchModel', 'subtitle'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyDetailsBranchModel', 'subtitle'),
    },
  };
}
